// The suite of AI tools published at tools.doctorgemma.com (the static
// "aitools" Cloudflare Worker — tools-gallery/public/index.html in this repo).
//
// Each entry's `id` MUST match the card's `data-tool` slug in the gallery HTML,
// because that slug is the key the admin's premium/free toggle writes to the
// `tool_settings` Supabase table, and the gallery reads back to decide which
// cards need a premium membership.
//
// `isPremium` here is only the DEFAULT shown before an admin has ever toggled a
// tool (mirrors how appConfig's isPremium seeds app_settings). The live value
// comes from tool_settings once saved. When you add a tool card to the gallery,
// add a matching entry here so it appears in the admin "AI tools" tab.

const toolsConfig = [
  {
    id: 'special-interest-maths-free',
    name: 'Special Interest Maths Worksheet Generator (Free)',
    category: 'Worksheets',
    isPremium: false,
    color: '#B9FBC0',
  },
  {
    id: 'special-interest-maths-premium',
    name: 'Special Interest Maths Worksheet Generator (Premium)',
    category: 'Worksheets',
    isPremium: true,
    color: '#A8DADC',
  },
  {
    id: 'special-interest-countdown-timer',
    name: 'Special Interest Countdown Timer',
    category: 'Timers',
    isPremium: false,
    color: '#FFD6A5',
  },
];

export default toolsConfig;
